export default {
    customer:{
        logintitle:'アカウント　ログイン',
        email:'メール',
        password:'パスワード',
        loginbtn:'ログイン',
        loginSuccess:'ログインしました',
        otherloginMode:'他のログイン方法',
        RechargeCore:'チャージセンター',
        RechargeCores:'チャージセンター - U.LU Games',
        AccountsDele:'アカウントが削除されました',
        AccountsSeal:'アカウントがブロックされました',
        PasswordError:'パスワードに誤りがあります',
        AccountsNotence:'アカウントが存在しません',
        EmailFormatError:'メールアドレスは正しくありません',
        PlacePassword:'パスワードを入力してください',
        PlaceEmail:'メールアドレスを入力してください',
        parameterIncomplete:'無効な型の引数',
        Rechargeption:'(チャージ説明)',
        Rechargeption2:'チャージ説明',
        obtainGameFail:'ゲームのロードに失敗しました、ページの再読み込みを試してください',
        placePayMode:'支払方法を選択してください',
    },
    RechargePage:{
        logout:'ログアウト',
        Rechargeccount:'アカウントチャージ',
        game:'ゲーム',
        TheServer:"サーバ",
        RoleNickname:"キャラ名",
        placeChTheSer:"サーバを選択してください",
        PlaceChNickN:"キャラ名を選択してください",
        PayMode:"支払方法",
        ChoosCommodity:"商品選択",
        OrderHathair:"注文未完成",
        HelpConCusSer:"ご意見、ご要望があれば、カスタマーセンターまでご連絡をお願いいたしますcs@ulugame.com",
        GlobalException:"グローバルエラー",
        good:"オッケー",
        OrderCompleted:"注文完了",
        SuccessBuy:"購入成功",
        Databaseerror:"データベースに異常があります",
        operror:"データベース異常操作",
        Invaildlogin:'ログイン無効、再度お試してください',
        Emailwasbinded:'本メールアドレスは連携済み',
        Codeerror:'認証コードは間違いました',
        bindedalready:'本アカウントは連携済み',
        ULUaccount:"本アカウントはULUアカウントと連携済みとなります",
        Codeinvalid:'認証コードは無効です',
        haveRegist:"アカウントは登録済み、ログインへ移動してください",
        Requestfrequently:"リクエストは頻繁です、少々お待ちしていただいて再度お試ください",
        notRegister:"未登録",
        oneBind:"全ての第三者アカウントの連携を解除する前に、一つのメールアドレスと連携してください",
        idError:"アカウントエラー、正しい未連携アカウントを入力してください",
        Noorvicnleund:'サーバーとキャラクターが見つかりません',
        gamesempty:'ゲームが空です',
        determin:'を選択して、',
        Ordercancelled:'注文はキャンセルされました',
        Rechargeonfirmation:'チャージ確認',
        Confirmwingarormation:'下記チャージ内容ご確認ください',
        BuyGoods:'商品購入',
        cancel:'キャンセル',

        RoleNickID:'キャラID',
        PlaceNickID:'キャラIDを入力してください',
        check:'検証',
        PlaceCheckID:'キャラIDを検証してください',
        CheckSuccess:'検証成功、キャラ名は:',
        VerificationFailed:'検証失敗、キャラは存在しません',
        SystemError:'システムエラー',
        InterfaceException:'接続異常',
        FrequentVisits:'アクセスが頻繁すぎます',
        NetworkAnomaly:'ネットワーク異常',
            PleLoginFirst:'ゲームアカウントをログインしてください',
        RecharRoleInformation:'キャラ情報',
        TotalAmount:'総金額',
        ImmediatePayment:'即支払',
        PleaseVerifyServer:'サーバ状況を検査してください',
        PayRole:'キャラ名',
        PlsselectRole:'キャラを選択してください'
    },
}
